import React from 'react';
import './BasicLabel.scss';

interface BasicLabelProps {
  label: string;
  isRequired: boolean;
}

const BasicLabel = (props: BasicLabelProps): JSX.Element => {
  const { label, isRequired } = props;
  return (
    <div className="basic-label-wrap">
      <span className="required-mark">{isRequired ? '*' : ''}</span>
      <label>{label}</label>
    </div>
  );
};

export default BasicLabel;
